/* ver 1.0 */

import * as THREE from "three";

export function EditControl(unify) {
  // internal
  const cameraRig = new THREE.Object3D();
  let velocityApplied = false;
  let upForceAdded = false;
  let deltaTime = 0;
  // positional vel
  let accel = 0.5;
  let drag = 0.2;
  let maxSpeed = new THREE.Vector3(0.07, 0.07, 0.07);
  let velocity = new THREE.Vector3(0, 0, 0);
  let constraints = new THREE.Vector3(49, 49, 49);
  let lastFrameMousePos = new THREE.Vector2();
  let currentMouseMove = new THREE.Vector2();
  let rotCapture = false;

  document.addEventListener("keydown", onKeyDown);
  document.addEventListener("keyup", onKeyUp);

  unify.scene.add(cameraRig);
  unify.addNewAsset("editModeRig", cameraRig);

  this.start = () => {
    cameraRig.position.copy(unify.camera.position);
    cameraRig.rotation.copy(unify.camera.rotation);
    cameraRig.add(unify.camera);
    unify.camera.position.set(0, 0, 0);
    unify.camera.rotation.set(0, 0, 0);
  };

  // key input
  const keyPress = {
    forward: false,
    back: false,
    left: false,
    right: false,
    up: false,
    down: false,
    space: false,
    pause: false
  };

  function onKeyDown(event) {
    var keycode = event.which;
    if (keycode == 87) {
      keyPress.forward = true; // key W
      //console.log("forward");
    }
    if (keycode == 65) {
      keyPress.left = true; // key A
      //console.log("left");
    }
    if (keycode == 83) {
      keyPress.back = true; // key S
      //console.log("back");
    }
    if (keycode == 68) {
      keyPress.right = true; // key D
      //console.log("right");
    }
    if (keycode == 32) {
      keyPress.space = true; // spacebar
    }
    if (keycode == 69) {
      keyPress.up = true; // key E
    }
    if (keycode == 67) {
      keyPress.down = true; // key C
    }
  }
  // KEYS: all key up actions
  function onKeyUp(event) {
    var keycode = event.which;
    if (keycode == 87) {
      keyPress.forward = false; // key W
    }
    if (keycode == 65) {
      keyPress.left = false; // key A
    }
    if (keycode == 83) {
      keyPress.back = false; // key S
    }
    if (keycode == 68) {
      keyPress.right = false; // key D
    }
    if (keycode == 32) {
      keyPress.space = false; // spacebar
    }
    if (keycode == 69) {
      keyPress.up = false; // key E
    }
    if (keycode == 67) {
      keyPress.down = false; // key C
    }
  }

  // check input
  function getDirectionalInput() {
    let vec3Input = new THREE.Vector3();
    if (keyPress.forward) {
      vec3Input.z = -1;
    }
    if (keyPress.back) {
      vec3Input.z = 1;
    }
    if (keyPress.space) {
      //vec3Input.y = 1;
      //(upForceAdded = vec3Input.y ? 1 : true), false;
    }
    if (keyPress.left) {
      vec3Input.x = -1;
    }
    if (keyPress.right) {
      vec3Input.x = 1;
    }
    if (keyPress.up) {
      vec3Input.y = 1;
    }
    if (keyPress.down) {
      vec3Input.y = -1;
    }
    return vec3Input;
  }

  function getRotationalInput() {
    if (unify.input.getMouseButton().left) {
      // button press

      let mousePosition = unify.input.getMousePosition();

      currentMouseMove.x = mousePosition.x; // - lastFrameMousePos.x;
      currentMouseMove.y = mousePosition.y; // - lastFrameMousePos.y;
      lastFrameMousePos = currentMouseMove;
      //console.log(currentMouseMove);
    } else {
      // not pressed
      rotCapture = false;
      currentMouseMove.set(0, 0);
    }

    return currentMouseMove;
  }

  // apply linear forces
  const addLinearForce = (vec3Input, deltaTime) => {
    if (vec3Input.x != 0 || vec3Input.z != 0 || vec3Input.y != 0) {
      velocity.z += vec3Input.z * accel * deltaTime;
      velocity.x += vec3Input.x * accel * deltaTime;
      velocity.y += vec3Input.y * accel * deltaTime;
      velocityApplied = false;
    }
  };

  // apply drag and clamp
  const calculateVelocity = (vec3Inputocity, drag, max, deltaTime) => {
    let outVel = 0;
    if (Math.abs(vec3Inputocity) > drag * deltaTime) {
      outVel = THREE.Math.clamp(
        vec3Inputocity > 0
          ? vec3Inputocity - drag * deltaTime
          : vec3Inputocity + drag * deltaTime,
        -max,
        max
      );
    } else {
      if (velocityApplied) {
        outVel = vec3Inputocity * 0.01;
      }
    }
    return outVel;
  };

  // ---------------
  // update
  this.update = deltaTime => {
    // get input
    addLinearForce(getDirectionalInput(), deltaTime);

    velocity.z = calculateVelocity(velocity.z, drag, maxSpeed.z, deltaTime);
    velocity.x = calculateVelocity(velocity.x, drag, maxSpeed.x, deltaTime);
    velocity.y = calculateVelocity(velocity.y, drag, maxSpeed.y, deltaTime);

    // gravity
    if (this.gravityEnabled) {
      if (!upForceAdded) {
        if (cameraRig.position.y > targetHeight) {
          velocity.y -= 0.05 * deltaTime;
        }
      } else {
        velocity.y = velocity.y < 0 ? 0 : velocity.y;
      }
      velocity.y = THREE.Math.clamp(velocity.y, -maxSpeed.y, maxSpeed.y);
      if (cameraRig.position.y >= constraints.y && upForceAdded) velocity.y = 0;
    }

    // apply new rotation
    let rotRig = cameraRig.rotation;
    rotRig.y -= getRotationalInput().x * deltaTime;
    cameraRig.rotation.copy(rotRig);
    let rotCam = unify.camera.rotation;
    rotCam.x += getRotationalInput().y * deltaTime;
    unify.camera.rotation.copy(rotCam);

    // apply new position
    cameraRig.translateZ(velocity.z);
    cameraRig.translateX(velocity.x);
    cameraRig.position.y += velocity.y;

    // constraints
    cameraRig.position.y = THREE.Math.clamp(
      cameraRig.position.y,
      -constraints.y,
      constraints.y
    );
    cameraRig.position.z = THREE.Math.clamp(
      cameraRig.position.z,
      -constraints.z,
      constraints.z
    );
    cameraRig.position.x = THREE.Math.clamp(
      cameraRig.position.x,
      -constraints.x,
      constraints.x
    );

    velocityApplied = true;
    upForceAdded = false;
  };
}
